<!-- 类目展示设置 -->
<template>
  <div class="index">
    <div class="title">
      <div class="span1">
        <span>{{ $route.name }}</span>
      </div>
    </div>
    <div class="group_radio">
      <p>请选择平台课程展示类目：</p>
      <el-radio-group v-model="category_type">
        <el-radio :label="'0'">五育类</el-radio>
        <el-radio :label="'1'">素质类</el-radio>
      </el-radio-group>
    </div>
    <div class="main">
      <img
        src="@/assets/img/categoryCourse/quality_bg.png"
        alt=""
        v-if="category_type === '0'"
      />
      <img
        src="@/assets/img/categoryCourse/teaching_bg.png"
        alt=""
        v-if="category_type === '1'"
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      tableData: [],
      category_type: "0",
    };
  },
  created(){

  },
  watch: {

  },
  methods: {
      
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }

  ::v-deep .el-form .el-input__inner {
    // width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }
  .group_radio {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    p {
      font-size: 16px;
      color: #333333;
      padding-right: 30px;
    }
  }
  .main {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-flow: wrap;
  }
}
</style>